"use client"

import { useWatch } from "react-hook-form"

import type { PropsWithClassName } from "~/@types/generics"
import { getFiltersAmount } from "~/components/ui/Panels/Filters/utils/get-filters-amount"
import { DrawerHeader } from "~/components/shared/Drawer/Header/index.client"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"

export function FiltersHeader({ className }: PropsWithClassName) {
  const t = useTranslate()
  const filters = useWatch()

  const selectedFiltersAmount = getFiltersAmount(filters)

  return (
    <DrawerHeader className={className} title={t("filter_panel_title")}>
      {selectedFiltersAmount > 0 && <span>{` (${selectedFiltersAmount})`}</span>}
    </DrawerHeader>
  )
}
